import { GRID_FILTERS_ADD, GRID_FILTERS_UPDATE, GRID_FILTERS_CLEAR } from '../../actions/constants/types';
import { GridFilterPages } from '../../enums/gridFilterPages';
import globals from '../../globals/communityGlobals';

const defaultVisitActualsFilters = {
  selectedTeams: [],
  selectedClinician: null,
  dateFrom: globals.now,
  dateTo: globals.now,
  nhsNumber: null,
  filtersRestrictions: {
    maxRangeInMonths: 3,
  },
};

const initialFiltersState = {
  items: [
    {
      key: GridFilterPages.VisitActuals,
      filters: defaultVisitActualsFilters,
    },
  ],
};

function gridFilters(state = initialFiltersState, action) {
  switch (action.type) {
    case GRID_FILTERS_ADD: {
      return {
        ...state,
        items: [...state.items, [{ [action.state.key]: action.state.filters }]],
      };
    }
    case GRID_FILTERS_UPDATE: {
      const index = state.items.findIndex(item => item.key === action.state.key);

      const newArray = [...state.items];
      newArray[index].filters = action.state.filters;

      return {
        ...state,
        items: newArray,
      };
    }
    case GRID_FILTERS_CLEAR: {
      const index = state.items.findIndex(item => item.key === action.state.key);

      const newArray = [...state.items];
      newArray[index].filters = defaultVisitActualsFilters;

      return {
        ...state,
        items: newArray,
      };
    }
    default: {
      return state;
    }
  }
}

export default gridFilters;
